import { type FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { BsCaretDown } from 'react-icons/bs';

import { type RootState } from '@editor2/reducers/root';
import { colorPaletteBlock } from './styles';
import { Button, Form } from 'react-bootstrap';
import { type PollChartType, type PollColorGroupByType, POLL_COLOR_GROUP_BY_MAP } from './types';

interface Props {
	courseId: number;
	color_palette: string;
	color_group_by: PollColorGroupByType;
	chart_type: PollChartType;
	onChange: (_) => void;
}

const ColorPaletteConfig: FC<Props> = (props) => {
	const {
		courseId,
		color_palette: colorPalette,
		color_group_by: colorGroupBy,
		chart_type: chartType,
		onChange
	} = props;

	const { color_palettes: configColorPalettes } = useSelector(
		(state: RootState) => state.courses[courseId].config
	);

	const [collapsed, setCollapsed] = useState(true);

	return (
		<div className={colorPaletteBlock}>
			<div className="header" onClick={() => setCollapsed(!collapsed)}>
				<div>Color configuration</div>
				<BsCaretDown className={collapsed ? 'collapseIconRotate' : 'collapseIcon'} />
			</div>

			{!collapsed && (
				<div className="body">
					<div>
						{configColorPalettes && (
							<>
								{Object.keys(configColorPalettes).map((key) => (
									<Form.Group className="colorPalette">
										<Form.Check
											type="radio"
											checked={key === colorPalette}
											onChange={() => onChange({ color_palette: key })}
											label={key}
										/>
										<div className="colorRow">
											{configColorPalettes[key].map((hex) => (
												<div className="colorBox" style={{ background: hex }} />
											))}
										</div>
									</Form.Group>
								))}
								<Button
									disabled={!colorPalette}
									className="clearSelectionButton"
									variant="outline-secondary"
									size="sm"
									onClick={() => onChange({ color_palette: null })}>
									Clear selection
								</Button>
							</>
						)}

						{!configColorPalettes && (
							<Form.Text>
								No color palettes are defined in the resource config. <br></br>
								This poll will use the default colors set for this theme.
							</Form.Text>
						)}
					</div>

					<Form.Group className="colorsGroupBy">
						<Form.Label>Assign colors by:</Form.Label>
						<Form.Control
							as="select"
							value={colorGroupBy}
							onChange={(e) => onChange({ color_group_by: e.target.value })}
							disabled={chartType === 'pie' || !chartType}>
							{Object.keys(POLL_COLOR_GROUP_BY_MAP).map((type) => (
								<option key={type} value={type}>
									{POLL_COLOR_GROUP_BY_MAP[type]}
								</option>
							))}
						</Form.Control>
					</Form.Group>
				</div>
			)}
		</div>
	);
};

export default ColorPaletteConfig;
